import TemplateGroupFilter from "./TemplateGroupFilter";

export default class TemplateGroups {
  public groupId: string = null;
  public label: string = null;
  public flags: string[] = [];
  public filters: TemplateGroupFilter = null;
}
